import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isHotKey from 'is-hotkey';
import scrollIntoView from 'scroll-into-view';
import { document } from '../../../../helpers/BrowserHelpers';
import getListElementPlacement from '../../../../plugins/utils/getListElementPlacement';
import TinyPopover from '../../../TinyPopover';
import { ChevronSmallDown, PlusIcon } from '../../../Icons';
import InputTransient from '../Utils/InputTransient';
import IconCell from '../IconCell';
import connectStore from '../../utils/connectStore';
import SelectItem from './SelectItem';
import ColumnTypes from '../../types/ColumnTypes';
import './index.css';

var SelectField =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SelectField, _React$PureComponent);

  function SelectField(props) {
    var _this;

    _classCallCheck(this, SelectField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectField).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onDropdownRef", function (ref) {
      if (!ref) return;
      _this.dropdownRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "onIconClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var _this$props = _this.props,
          database = _this$props.database,
          record = _this$props.record,
          column = _this$props.column;
      database.activate(record.key, column.key).focus();

      _this.setState({
        isOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      return _this.setState({
        isOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      _this.props.setStore({
        value: value
      });

      _this.setState({
        index: 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event, next) {
      if (isHotKey('up', event)) {
        return _this.onArrowUp(event);
      }

      if (isHotKey('down', event)) {
        return _this.onArrowDown(event);
      }

      if (isHotKey('backspace', event) && _this.props.value === '') {
        return _this.onRemoveLastCellItem(event);
      }

      next();
    });

    _defineProperty(_assertThisInitialized(_this), "onArrowUp", function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (_this.state.index > 0) {
        _this.focusItem(_this.state.index - 1);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onArrowDown", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var maxIndex = _this.state.cellItems.length;

      if (_this.state.index < maxIndex - 1) {
        _this.focusItem(_this.state.index + 1);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "focusItem", function (index) {
      _this.setState({
        index: index
      });

      var item = document.querySelector("[data-selectfield-item-index='".concat(index, "']"));

      if (!item) {
        console.warn('Database SelectField - Cant find item to focus in DOM');
        return;
      }

      var _getListElementPlacem = getListElementPlacement(item, _this.dropdownRef),
          visible = _getListElementPlacem.visible,
          top = _getListElementPlacem.top;

      if (!visible) {
        scrollIntoView(item, {
          time: 0,
          align: {
            top: top ? 0 : 1,
            topOffset: top ? 10 : -10
          },
          validTarget: function validTarget(target) {
            return target.className && target.className.indexOf('slite-editor-database-popover') >= 0;
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveLastCellItem", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var listItems = _this.props.listItems;

      _this.onRemoveCellItem(listItems[listItems.length - 1]);
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveCellItem", function (item) {
      _this.props.onRemoveCellItem(item);

      _this.getCellItems('');
    });

    _defineProperty(_assertThisInitialized(_this), "onNewCellItem", function (event) {
      event.stopPropagation();
      event.preventDefault();
      var index = _this.state.index;
      var _this$props2 = _this.props,
          value = _this$props2.value,
          onNewCellItem = _this$props2.onNewCellItem,
          setStore = _this$props2.setStore,
          database = _this$props2.database;
      if (!_this.state.cellItems[index]) return;
      database.activate();
      onNewCellItem(_this.state.cellItems[index], value);
      setStore({
        value: ''
      });

      _this.setState({
        index: 0
      });

      _this.getCellItems('');
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseMove", function (index) {
      return function (event) {
        if (_this.state.index !== index) {
          _this.setState({
            index: index
          });
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getCellItems", function (value) {
      return _this.props.getCellItems(value).then(function (cellItems) {
        return _this.setState({
          cellItems: cellItems
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderListItem", function (item, index) {
      var _this$props$renderLis = _this.props.renderListItem(item, index),
          _this$props$renderLis2 = _this$props$renderLis.wrapperProps,
          wrapperProps = _this$props$renderLis2 === void 0 ? {} : _this$props$renderLis2,
          _this$props$renderLis3 = _this$props$renderLis.child,
          child = _this$props$renderLis3 === void 0 ? null : _this$props$renderLis3;

      return React.createElement("div", Object.assign({
        key: item.key,
        className: "inline-block database-selectfield-item"
      }, wrapperProps), React.cloneElement(React.Children.only(child), {
        onRemove: function onRemove(event) {
          event.preventDefault();
          event.stopPropagation();

          _this.onRemoveCellItem(item);
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCellItem", function (item, index) {
      var value = _this.props.value;

      var _this$props$renderCel = _this.props.renderCellItem(item, index, value),
          _this$props$renderCel2 = _this$props$renderCel.wrapperProps;

      _this$props$renderCel2 = _this$props$renderCel2 === void 0 ? {} : _this$props$renderCel2;

      var className = _this$props$renderCel2.className,
          wrapperProps = _objectWithoutProperties(_this$props$renderCel2, ["className"]),
          _this$props$renderCel3 = _this$props$renderCel.child,
          child = _this$props$renderCel3 === void 0 ? null : _this$props$renderCel3;

      return React.createElement(SelectItem, Object.assign({
        key: item.key,
        isSelected: index === _this.state.index,
        onClick: _this.onNewCellItem,
        onMouseMove: _this.onMouseMove(index),
        "data-selectfield-item-index": index,
        className: classNames('database-selectfield-selectitem', className)
      }, wrapperProps), child);
    });

    _defineProperty(_assertThisInitialized(_this), "renderCellItems", function () {
      var column = _this.props.column;
      var cellItems = _this.state.cellItems;
      var items = cellItems.map(_this.renderCellItem);
      var selectTypes = [ColumnTypes.MULTI_SELECT, ColumnTypes.SELECT];
      return React.createElement(React.Fragment, null, items, items.length === 0 && selectTypes.includes(column.type) && React.createElement(SelectItem, {
        className: "shade-30 padding-small",
        style: {
          cursor: 'default'
        }
      }, "+ start typing to create a new tag"));
    });

    _this.state = {
      index: 0,
      cellItems: [],
      isOpen: false
    };
    _this.dropdownRef = null;
    return _this;
  }

  _createClass(SelectField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getCellItems(this.props.value);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps, previousState) {
      if (previousProps.value !== this.props.value || !previousProps.isFocused && this.props.isFocused) {
        this.getCellItems(this.props.value);
      }

      if (previousProps.isFocused && !this.props.isFocused) {
        this.onBlur();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          attributes = _this$props3.attributes,
          tooltipMessage = _this$props3.tooltipMessage,
          isFocused = _this$props3.isFocused,
          listItems = _this$props3.listItems,
          value = _this$props3.value,
          isActive = _this$props3.isActive,
          multiSelect = _this$props3.multiSelect,
          database = _this$props3.database;
      var isOpen = this.state.isOpen;
      return React.createElement(TinyPopover, {
        isOpen: isFocused && (isOpen || value.length > 0),
        position: "bottom",
        align: "start",
        content: this.renderCellItems // overrides default `overflow: hidden`, allowing box-shadows to be visible
        ,
        containerStyle: function containerStyle(_ref) {
          var width = _ref.width;
          return {
            maxHeight: 200,
            overflow: 'auto',
            minWidth: Math.min(width, 400) + 1
          };
        },
        className: classNames(['slite-editor-database-popover slite-design-system', 'zindex-large position-absolute inline-block', 'radius-normal scroll-y', 'background-white border-none', 'shadow-hovering']),
        onTooltipRef: this.onDropdownRef
      }, React.createElement("div", Object.assign({
        "data-qa": "database-select-field"
      }, attributes, {
        style: {
          minHeight: 40
        },
        className: classNames('position-relative database-selectfield', 'flexbox-grow flexbox shade-05')
      }), React.createElement(IconCell, {
        icon: multiSelect ? PlusIcon : ChevronSmallDown,
        tooltip: tooltipMessage,
        isActive: isActive,
        onClick: this.onIconClick
      }, listItems.map(this.renderListItem), isFocused && React.createElement(InputTransient, {
        className: classNames('database-selectfield-input flexbox-grow'),
        autoFocus: isFocused,
        placeholder: "",
        value: value,
        readOnly: database.readOnly || !isFocused,
        onChange: this.onChange,
        debounceTimeout: 0,
        onKeyDown: this.onKeyDown,
        onEnter: this.onNewCellItem
      }))));
    }
  }]);

  return SelectField;
}(React.PureComponent);

_defineProperty(SelectField, "propTypes", {
  database: PropTypes.object,
  record: PropTypes.object,
  column: PropTypes.object,
  attributes: PropTypes.object,
  isFocused: PropTypes.bool,
  isActive: PropTypes.bool,
  listItems: PropTypes.array,
  renderListItem: PropTypes.func,
  onNewCellItem: PropTypes.func,
  onRemoveCellItem: PropTypes.func,
  renderCellItem: PropTypes.func,
  getCellItems: PropTypes.func,
  value: PropTypes.string,
  setStore: PropTypes.func,
  multiSelect: PropTypes.bool,
  tooltipMessage: PropTypes.string
});

_defineProperty(SelectField, "defaultProps", {
  listItems: [],
  getCellItems: function getCellItems() {
    return Promise.resolve([]);
  },
  onNewCellItem: function onNewCellItem() {
    return true;
  },
  renderListItem: function renderListItem() {
    return null;
  },
  renderCellItem: function renderCellItem() {
    return null;
  },
  value: '',
  tooltipMessage: 'Add tag'
});

export default connectStore()(SelectField);